module.exports = __webpack_public_path__ + "img/icon-logo.43f498d0.png";